<template>
  <div
    v-if="enabled"
    :id="'scroller-' + uniqId"
    :class="['scroller', 'scroller--' + variant, 'baron', 'baron__root', 'baron__clipper', '_simple']"
    :style="{ maxHeight: height }"
  >
    <div class="baron__scroller">
      <slot />
    </div>

    <div
      class="baron__track"
      :style="{ top: topPosition }"
    >
      <div class="baron__free">
        <div
          class="baron__bar"
        />
      </div>
    </div>
  </div>

  <div v-else class="default">
    <slot />
  </div>
</template>

<script>
import baron from 'baron'

export default {
  props: {
    enabled: {
      type: Boolean,
      default: true
    },
    height: {
      type: String,
      default: '479px'
    },
    topPosition: {
      type: String,
      default: '1px'
    },
    variant: {
      type: String,
      default: 'light',
      validator (values) {
        return ['light', 'dark'].includes(values)
      }
    }
  },
  data () {
    return {
      uniqId: (Math.random() + 1).toString(36).substring(2)
    }
  },
  mounted () {
    if (this.enabled === true) {
      baron({
        scroller: '#scroller-' + this.uniqId,
        track: '.baron__track',
        bar: '.baron__bar',
        scrollingCls: '_scrolling',
        position: 'relative'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';
@import "~baron/skins/styles.css";

.default {
  width: 100%;
}

.scroller {
  width: 100%;
  right: -0px;
  height: auto;
  max-height: inherit;
  overflow: auto;
  scrollbar-color: $bg-1 rgba($bg-1, 0);
}

::-webkit-scrollbar {
  width: 0;
}

._scrolling {
  pointer-events: none;
  user-select: none;
}

.baron._simple .baron__track {
  bottom: 1px !important;
  right: 0px !important;
}

.baron._simple.baron .baron__bar {
  width: 10px !important;
  opacity: 1 !important;
}

.scroller--light.baron._simple .baron__track {
  width: 10px !important;
  background: rgba($bg-1, 0.5) !important;
}

.scroller--light.baron._simple .baron__bar {
  background: darken($bg-1, 0) !important;
  border-radius: 99px !important;
  min-height: 64px;
}

.scroller--dark.baron._simple .baron__track {
  width: 10px !important;
  background: rgba($bg-1, 0.5) !important;
}

.scroller--dark.baron._simple .baron__bar {
  background: darken($bg-1, 3) !important;
  border-radius: 99px !important;
}

.scroller {
  -ms-overflow-style: none;
  scrollbar-width: none;
  overflow-y: scroll;
}

.scroller::-webkit-scrollbar {
  display: none;
}

</style>
